var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"storeDistribution"}},[_c('div',{staticClass:"title-top bg-f"},[_vm._v("门店分布")]),_vm._v(" "),_c('div',{staticClass:"map_content bg-f mt-5"},[_c('store-map')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }